import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import { mutationType as userProfile } from '../userProfile/mutation-types'
import RegisterState, { IRegisterFormData } from './states'
import _ from 'lodash'
import store, { State } from '@/store/store'
import { hashFunction } from '@/services/Helpers'
import httpServiceWithToken from '@/services/HttpRequestServiceWithToken'

export interface IRegisterStatus {
  registerStatus: boolean,
  code: number,
  message: string
}

const actions: ActionTree<RegisterState, State> = {
  async PostRegisterData(
    { commit, dispatch, state }: ActionContext<RegisterState, State>,
    registerData: IRegisterFormData,
  ): Promise<IRegisterStatus> {
    try {
      await httpServiceWithToken.post(
        process.env.VUE_APP_API_URL + '/v1/authentication/signup',
        registerData,
        (res) => {
          commit(mutationType.GET_USER_ID, res._id)
          commit(userProfile.GET_USER_PROFILE, res)
        },
      )
      return {
        registerStatus: true,
        code: 200,
        message: 'Signup Success',
      }
    } catch (error) {
      throw {
        registerStatus: false,
        code: error.response.data.status,
        message: error.response.data.message,
      }
    }
  },
}

export default actions
